import { keyframes } from 'styled-components'

// Adapted for min-width
const breakpoint = {
  tablet: 768,
  tabletLandscape: 1024,
  tabletMid: 800,
  tabletMidLandscape: 1080,
  desktop: 1025,
  mediumDesktop: 1280,
}

const devices = {
  mobile: `screen and (max-width: ${breakpoint.tablet}px)`,
  tablet: `screen and (min-width: ${breakpoint.tablet}px)`,
  tabletLandscape: `screen and (min-width: ${breakpoint.tabletLandscape}px)`,
  tabletMid: `screen and (min-width: ${breakpoint.tabletMid}px)`,
  tabletMidLandscape: `screen and (min-width: ${breakpoint.tabletMidLandscape}px)`,
  desktop: `screen and (min-width: ${breakpoint.desktop}px)`,
  mediumDesktop: `screen and (min-width: ${breakpoint.mediumDesktop}px)`,
}

const animations = {
  fadeIn: keyframes`
    from {
      opacity: 0;
      visibility: hidden
  }
    to {
      opacity: 1;
      visibility: visible
  }
  `,

  slideLeft: keyframes`
    from {
      transform: translateX(100%);
      opacity: 0;
      visibility: hidden
  }
    to {
      transform: translateX(0);
      opacity: 1;
      visibility: visible
  }
  `,
  // should have transform-origin: top
  dropDown: keyframes`
  from {
    transform: scaleY(0.5);
    opacity: 0.5;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
  `,
  flicker: keyframes`
    0%   { opacity: 1; }
    50%  { opacity: 0; }
    100% { opacity: 1; }
  `,
  spin: keyframes`
  from {transform: rotate(0)} 
  to { transform: rotate(360deg) } `,
}

const theme = {
  colors: {
    accentGold: '#E8B97A',
    accent10: 'rgba(239, 153, 103, 0.1)',
    anotherDarkGrey: '#5F5F5F',
    beachGrey: '#D2CCC1',
    black: '#000000',
    darkestGrey: '#3F3F3F',
    darkeyGrey: '#A5A5A5',
    dimmedGold: '#BBA88C',
    disabledGrey: '#747271',
    dolphinGrey: '#AEA69B',
    duneWarmGrey: '#696057',
    error: '#C5292A',
    lightRed: '#DB542A1A',
    green: '#0AD042',
    grey: '#F8F8F8',
    moreGrey: '#807E7E',
    lighterGrey: '#F9F9F9',
    horizonOrange: '#FF5F00',
    menuDark: '#454443',
    otterWarmBlack: '#382E2B',
    lightGrey: '#F2F2F2',
    newDarkGrey: '#747271',
    newLightGrey: '#EBEBEB',
    pelicanGrey: '#DBD9D6',
    success: '#2DA771',
    successBright: '#1BC77B',
    successGreen: '#23C514',
    successBack: '#F4FCF3',
    statusYellow: '#F3DF2D',
    lightYellow: '#F3DF2D1A',
    unsuccessBack: 'rgba(219, 84, 42, 0.1)',
    white: '#FFFFFF',
    hoverState: '#f2ebe1',
    hover10: '#FDF5F0',
    activeState: '#EDEAE5',
    newGrey: '#EFEDEB',

    cstBackgroundGrey: '#201E1D',
    newBackgroundGrey: '#121111',
    popupBrownGrey: '#272523',
    nonTransparentHighlight: '#3D3834',

    separatorColor: 'rgba(162, 149, 132, 0.2)',
    mutedGray: '#A39689',
    inputFill: 'rgba(105, 96, 87, 0.15)',
    inputFillFocus: 'rgba(105, 96, 87, 0.4)',
    commonShadow: 'rgba(0, 0, 0, 0.1)',
    dropZone: 'rgba(255, 95, 0, 0.08)',
    dropZoneDark: 'rgba(255, 95, 0, 0.13)',

    menuHover: '#575756',
  },

  fonts: {
    base: 'Montserrat, Roboto, sans-serif',
  },

  spacing: {
    tiny: '4px',
    xxs: '6px',
    xs: '8px',
    s: '12px',
    base: '16px',
    sm: '20px',
    md: '24px',
    lg: '32px',
    xl: '36px',
    xxl: '40px',
    xxxl: '48px',
    large: '64px',
    xlarge: '80px',
  },

  sizes: {
    maxContentWidth: '1440px',
    headerHeight: '64px',
    footerHeight: '156px',
  },

  breakpoint,

  devices,

  animations,

  zIndex: {
    bgImage: '-200',
    bgOverlay: '-199',
    loaderOverlay: '100',
    homeAside: '96',
    tooltip: '101',
    alertBanner: '97',
    fixedHeader: '98',
    modal: 99,
  },

  /* For darkening overlays, gradients, etc */
  overlay: {
    darkImage: 'rgba(0, 0, 0, 0.5)',
    cardColor2: 'rgba(60, 56, 51, 0.5)',
    SBlur: 'blur(20px)',
    newDropdownBlack: 'rgba(0, 0, 0, 0.7)',
    newMenuHover: 'rgba(105, 96, 87, 0.3)',
    inputFillFocus: 'rgba(105, 96, 87, 0.4)',
    menuHover: 'rgba(53, 50, 49, 0.5)',
    slightLight: 'rgba(165, 165, 165, 0.1);',
    bgBeachOpac: 'rgba(187, 168, 140, 0.2)',
    modalCommon: 'rgba(0, 0, 0, 0.5)',
  },
}

export default theme
